import { Component } from "@angular/core";
import {
  Platform,
  NavParams,
  ViewController,
  LoadingController,
  AlertController
} from "ionic-angular";
import { SummaryServiceProvider } from "../../../../providers/wh/summary-service";

@Component({
  selector: "transfer-site-modal",
  templateUrl: "transfer-site-modal.html",
  providers: [SummaryServiceProvider]
})
export class TransferSiteModalComponent {
  text: string;
  daysList;
  data;
  newSiteId;
  newCPData: any;
  newCPDataObj: any;
  initialView: any;
  transferView: any;
  wrongAwb: any;
  reason: any;

  constructor(
    public platform: Platform,
    public params: NavParams,
    public loadingCtrl: LoadingController,
    public summaryService: SummaryServiceProvider,
    private alertCtrl: AlertController,
    public viewCtrl: ViewController
  ) {
    this.text = "Hello World";
    this.data = this.params.get("data");
    this.initialView = true;
    //this.data = this.params;
  }

  verifyNewSiteId(show_loader) {
    this.wrongAwb = false;
    let q: any = "";
    this.newCPDataObj = [];
    this.newCPData = "";
    if (this.newSiteId !== "") {
      q += "siteId=" + this.newSiteId;
    }
    if (show_loader) {
      let loader = this.loadingCtrl.create({
        content: "Please wait..."
      });
      loader.present();
      this.summaryService.load_cp_data(q).then((data: any) => {
        if (data.data.content.length > 0) {
          this.newCPData = data;
          this.newCPDataObj = this.newCPData.data.content[0];
          this.initialView = false;
          this.transferView = true;
        } else {
          this.wrongAwb = true;
        }
      });
      loader.dismiss();
    }
  }

  confirmTransferSite(id) {
    var message = "Do you want to confirm the site transfer";
    let alert = this.alertCtrl.create({
      title: "Confirm",
      message: `${message}`,
      buttons: [
        {
          text: "No",
          role: "cancel",
          handler: () => {
            console.log("Cancel clicked");
          }
        },
        {
          text: "Yes",
          handler: () => {
            var payload = {
              stationId: id,
              actionType: "CHANGE_CP",
              reason: this.reason
            };
            this.summaryService
              .putTransferCP(this.data.orderNo, payload)
              .then(res => {
                console.log(res);
                // console.log("Confirmed");
                this.viewCtrl.dismiss(true);
              });
          }
        }
      ]
    });
    alert.present();
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/backoffice/shipments/transfer-site-modal/transfer-site-modal.ts